import md5 from 'tiny-hashes/md5';
export function extendCoreVideo() {
    [].slice.apply(document.querySelectorAll('.wp-block-video')).forEach(applyPatch);
}
function applyPatch(block) {
    var cover = document.createElement('div');
    var video = block.querySelector('video');
    var icon = document.createElement('span');
    var caption = block.querySelector('figcaption');
    cover.classList.add('-stub');
    icon.classList.add('icon', 'icon-video-player');
    cover.appendChild(icon);
    cover.appendChild(caption);
    block.appendChild(cover);
    block.addEventListener('click', playVideo);
    if (video.autoplay && block.classList.contains('autoplay-when-once')) {
        playOnce();
    }
    function playVideo() {
        cover.classList.add('is--hidden');
        video.controls = true;
        video.play();
    }
    function playOnce() {
        var cookieId = "core-video-autoplay-once-".concat(md5(video.src));
        video.removeAttribute('autoplay');
        video.load();
        var regexp = new RegExp(cookieId);
        if (document.cookie.match(regexp)) {
            return;
        }
        video.muted = true;
        var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting && video.paused) {
                    playVideo();
                }
                else if (video.muted) {
                    video.pause();
                }
            });
        }, {
            threshold: 0.5,
        });
        io.observe(block);
        video.addEventListener('ended', function () {
            io && io.disconnect();
            setCookieStatus();
        });
        function setCookieStatus(days) {
            if (days === void 0) { days = 1; }
            var date = new Date((new Date()).getTime() + 86400000 * Math.max(0.01, days));
            document.cookie = "".concat(cookieId, "=; expires=").concat(date.toISOString());
        }
    }
}
